export type TChatSenderType = 'USER' | 'SELLER' | 'SUPPORT'

export type TChatType = 'SELLER' | 'SUPPORT'

export enum ESupportChatTab {
  SELLERS = 'SELLERS',
  BUYERS = 'BUYERS'
}

export interface IChatProduct {
  _id: string
  name: string
  slug?: string
  photo?: string[] | string
  price?: number
}

export interface IChatUser {
  _id: string
  name?: string
  surname?: string
  full_name?: string
}

export interface IChatSeller {
  _id: string
  slug?: string
  shop_details?: {
    shop_name?: string
  }
}

export interface IChat {
  _id: string
  type?: TChatType
  user_id?: IChatUser
  seller_id?: IChatSeller | null
  support_seller_id?: IChatSeller | null
  last_product?: IChatProduct | null
  last_message_text?: string
  last_message_at?: string
  last_message_sender_type?: TChatSenderType
  unread_for_user?: number
  unread_for_seller?: number
  unread_for_support?: number
  // Обращение гостя из виджета на сайте: аккаунта нет, есть только имя и почта
  guest_id?: string | null
  contact_name?: string | null
  contact_email?: string | null
}

// MP4 и кадр-обложка в хранилище картинок
export interface IChatVideo {
  src: string
  poster: string
}

export interface IChatMessage {
  _id: string
  chat_id: string
  product_id?: IChatProduct | null
  sender_type: TChatSenderType
  sender_user_id?: string | null
  // Имя и фамилия оператора — только в эндпоинтах поддержки для админов
  sender_name?: string
  text: string
  // Ключи фото в хранилище картинок; у сообщения из одних фото или видео text пустой
  images?: string[]
  videos?: IChatVideo[]
  is_read_by_user?: boolean
  is_read_by_seller?: boolean
  is_read_by_support?: boolean
  is_auto_reply?: boolean
  is_internal?: boolean
  edited_at?: string | null
  // До какого времени автор может изменить сообщение; null — без срока
  editable_until?: string | null
  createdAt?: string
}

export interface ISendChatMessageRequest {
  product_id: string
  text: string
}

export interface IUnreadChatCountResponse {
  unreadCount: number
}

export interface IChatMessageCreatedPayload {
  chatId: string
  chat?: IChat
  message: IChatMessage
}

export interface IChatListUpdatedPayload {
  chat: IChat
}

export interface IChatUnreadCountUpdatedPayload {
  unreadCount: number
}

export interface IChatReadPayload {
  chatId: string
  actorType: TChatSenderType
}

export interface ISendChatMessageAck {
  success: boolean
  message?: IChatMessage | string
}


export interface ISupportChatResponse {
  chat: IChat | null
}

export interface ISupportClientInfo {
  app: 'SELLER_CABINET'
  app_version?: string
  page_url?: string
  timezone?: string
  timezone_offset?: number
  language?: string
  screen?: string
}

export interface ISendSupportMessageRequest {
  text: string
  client?: ISupportClientInfo
}

export interface ISendSupportMessageResponse {
  chat: IChat
  message: IChatMessage
}

export interface ISupportUnreadCounters {
  sellers: number
  buyers: number
  total: number
}

// Гость вошёл в аккаунт, и его обращение влилось в обращение аккаунта
export interface ISupportChatRemovedPayload {
  chatId: string
  mergedInto?: string
}

export interface ISupportChatUpdatedPayload {
  chat: IChat
}

export interface ISupportChatUnreadResponse {
  chat: IChat
  message: IChatMessage
}
